import { useEffect, useRef } from 'react';
import { useConversationStoreShallow } from 'src/store/conversationStore';

import { useResponsive } from '@utils/hooks/useResponsive';

import { SingleMessage } from '@domains/new-conversation/atoms/SingleMessage/SingleMessage';
import { ResponseMessage } from '@domains/new-conversation/molecules/ResponseMessage/ResponseMessage';
import {
    ChatWrapper,
    MessagesWrapper,
} from '@domains/new-conversation/organisms/ConversationChatDisplay/ConversationChatDisplay.styled';
import { ContentScrollbar } from '@domains/new-conversation/pages/Conversation.styled';

export const ConversationChatDisplay = () => {
    const scrollBar = useRef<HTMLDivElement>(null);

    const { messages } = useConversationStoreShallow(['messages']);
    const conversationLength = messages.length;

    const isMd = useResponsive('md');

    const messagesToRender = (
        <MessagesWrapper>
            {messages.map((message, index) => {
                return (
                    <div key={`ChatDisplay-${index}`}>
                        {message.type === 'ASSISTANT' ? (
                            <ResponseMessage message={message} />
                        ) : (
                            <SingleMessage
                                isUserMessage
                                key={`UserAnswer${index}`}
                            >
                                {message.text}
                            </SingleMessage>
                        )}
                    </div>
                );
            })}
        </MessagesWrapper>
    );

    useEffect(() => {
        if (!isMd) {
            const conversationHeight = scrollBar?.current?.scrollHeight ?? 0;

            scrollBar?.current?.scrollTo(0, conversationHeight);
        } else {
            const conversationContentEl = document.getElementById(
                'conversation-content',
            );
            setTimeout(() => {
                conversationContentEl?.scrollTo(
                    0,
                    conversationContentEl.scrollHeight,
                );
            }, 10);
        }
    }, [conversationLength, isMd]);

    return (
        <ChatWrapper ref={scrollBar}>
            {isMd ? (
                messagesToRender
            ) : (
                <ContentScrollbar>{messagesToRender}</ContentScrollbar>
            )}
        </ChatWrapper>
    );
};
